import { ComponentType } from 'react'

import { ActionConfigurationIdentifiers } from 'modules/processes/domain'
import { Editor } from 'modules/surveys/Actions/SendSurveyAction/Editor'
import { Preview } from 'modules/surveys/Actions/SendSurveyAction/Preview'
import { Selector } from 'modules/surveys/Actions/SendSurveyAction/Selector'

import { sendCustomEmailWizardActions } from 'modules/processes/components/ItemWizard/Actions/SendCustomEmail'
import { SelectorProps } from './types'

export interface EditorProps {
  identifier: ActionConfigurationIdentifiers
}

export interface PreviewProps {
  identifier: ActionConfigurationIdentifiers
}

export type ActionWizardStepTypes = 'selector' | 'editor' | 'preview'

interface WizardSections {
  selector: ComponentType<SelectorProps>
  editor: ComponentType<EditorProps>
  preview: ComponentType<PreviewProps>
}

type WizardActions = Partial<Record<ActionConfigurationIdentifiers, WizardSections>>

export type ActionComponent = (props: SelectorProps | EditorProps | PreviewProps) => JSX.Element

export const wizardConfiguredActions = (): WizardActions => {
  const sendSurveyAction = {
    [ActionConfigurationIdentifiers.SendSurvey]: {
      selector: Selector,
      preview: Preview,
      editor: Editor,
    },
  }

  const processesActions: WizardActions = {
    ...sendCustomEmailWizardActions,
    ...sendSurveyAction,
  }

  return Object.assign({}, processesActions)
}
